import { AlertType } from "src/api/types";

export enum TableColumnKey {
  Operation = "operation",
  ClientId = "client_id",
  ChainCode = "chain_code",
  ChainName = "chain_name",
  Currency = "currency",
  AlertType = "alert_type",
  AlertTypeName = "alert_type_name",
  StepValue = "step_value",
  Balance = "balance",
  ThresholdLower = "threshold_lower",
  ThresholdUpper = "threshold_upper",
  CreationTime = "creation_time",
  LastModifiedTime = "last_modified_time",
}
export type TableRow = {
  [TableColumnKey.Operation]: string;
  [TableColumnKey.ClientId]: string;
  [TableColumnKey.ChainCode]: string;
  [TableColumnKey.ChainName]: string;
  [TableColumnKey.Currency]: string;
  [TableColumnKey.AlertType]: AlertType;
  [TableColumnKey.StepValue]: string;
  [TableColumnKey.Balance]: string;
  [TableColumnKey.ThresholdLower]: string;
  [TableColumnKey.ThresholdUpper]: string;
  [TableColumnKey.CreationTime]: string;
  [TableColumnKey.LastModifiedTime]: string;
};
